// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z_Sf","type":"styles_type__KSqlu","choices":"styles_choices__nkFkp"};